<template lang="html">

  <div class="ficha" :data="productColor">

    <section class="intro">

      <div class="container row-between ais">

        <div class="texto column-start">

          <router-link class="back" :to="$t('enlaces.servicios')">{{$t('productos_list.titleProduct')}}</router-link>

          <div class="info-producto">

            <h1 class="title -intro" v-html="$t(`ficha_producto['${$route.params.id}'].nombre`)"></h1>

            <div class="texto-intro" v-html="$t(`ficha_producto['${$route.params.id}'].texto_intro`)"></div>

          </div>


        </div>

        <div class="imagen">
          <img :src="`/static/img/gifs/${$t(`ficha_producto['${$route.params.id}'].imagen`)}.gif`" :alt="$t(`ficha_producto['${$route.params.id}'].texto_intro`)">
        </div>


      </div>

    </section>


    <section class="stats container row-center aifs">

      <div class="left">

        <div class="descripcion">

          <h3 class="title -intro">{{texts[0][0]}}:</h3>

          <div v-html="texts[0][1]"></div>

        </div>

        <div class="dirigido" v-if="!!texts[2]">

          <h3 class="title -intro">{{texts[2][0]}}:</h3>

          <div v-html="texts[2][1]"></div>

        </div>


        <div class="descripcion" v-if="!!texts[3]">

          <h3 class="title -intro">{{texts[3][0]}}:</h3>

          <div v-html="texts[3][1]"></div>

        </div>

      </div>

      <div class="right" v-if="!!texts[1]">

        <div class="utilidad">

          <h3 class="title -intro">{{texts[1][0]}}:</h3>

          <div v-html="texts[1][1]"></div>


        </div>


        <!-- <div class="video" v-if="$t(`ficha_producto['${$route.params.id}'].video`) != 'false'">

          <button class="enlace-cover" @click="toggleVideo"></button>

        </div> -->

      </div>
      <!-- <div class="img-ficha row-center" v-if="$t(`ficha_producto['${$route.params.id}'].imgFicha`) != 'false'">
      <img :src="`/static/img/fichas-img/${$t(`ficha_producto['${$route.params.id}'].imagen`)}.png`"
        :alt="$t(`ficha_producto['${$route.params.id}'].texto_intro`)">
      </div> -->

    </section>

    <section class="saber-mas" v-if="showSaberMas && lang =='es'">

      <div class="container-xs column-center">

        <h2 class="title">{{$t('ficha_producto.bannerFooterTitle')}}</h2>

        <p>{{$t('ficha_producto.bannerFootersubtitle')}}</p>

        <p>{{$t('ficha_producto.bannerFooterDescription')}}</p>

        <button @click="desplegado = !desplegado" class="show-more">
          <img src="/static/img/down.svg" alt="Desplegable">
        </button>

      </div>

    </section>


    <!-- <casos-exito :data="$t(`ficha_producto['${$route.params.id}'].caso_exito`)" v-show="desplegado"></casos-exito> -->
    <hablan-de-nosotros v-if="desplegado"></hablan-de-nosotros>
    <!-- <hablan-de-nosotros :comentarios="$t(`ficha_producto['${$route.params.id}'].comentarios`)" v-if="desplegado"></hablan-de-nosotros> -->

    <video-viewer v-on:closeVideo="toggleVideo" :show="show_video" :id="$t(`ficha_producto['${$route.params.id}'].video`)"></video-viewer>


  </div>

</template>

<script lang="js">

  import router from '@/router';

  import { mapGetters } from 'vuex';

  import video from '@/components/parts/video-viewer';

  import hablanDeNosotros from '@/components/view-parts/clientes/hablan-de-nosotros'

  import casosExito from '@/components/parts/casos-exito'

  export default {
    name: 'producto-ficha',
    props: ['id'],
    mounted() {
      (!!!this.productColor) ? router.push('/productos') : '';
    },
    data() {
      return {
        show_video: false,
        desplegado: false
      }
    },
    components: {
      'video-viewer': video,
      'hablan-de-nosotros': hablanDeNosotros,
      'casos-exito': casosExito
    },
    methods: {
      toggleVideo: function () {
        this.show_video = !this.show_video;
      }
    },
    computed: {
      ...mapGetters(['getTexts']),
      ...mapGetters({
        lang: 'getLanguage'
      }),
      productColor: function () {
        let color = {
          rojo: ['empresa', 'firma-digitalizzata'],
          gris: ['centro-de-formacion', 'orientamento-professionale'],
          verde: ['gestor-de-formacion', 'gestionale-per-la-formazione'],
          azul: ['sector-publico', 'crm-fondi-interprofessionali'],
          negro: ['robotic-process-automatation', 'agencia-de-colocacion'],
        };

        let how;

        for (let i in color) {
          (color[i].some(el => el == this.$route.params.id)) ? how = i : '';
        }

        return how;
      },
      texts: function () {
        return Object.entries(this.getTexts.ficha_producto[this.$route.params.id].propiedades);
      },
      showSaberMas: function () {

        let producto = this.getTexts.ficha_producto[this.$route.params.id];

        let flag = (!!producto.comentarios || !!producto.caso_exito);

        return flag;

      }
    }
  }
</script>

<style scoped>
  .intro {
    width: 100%;
    /* height: 75vh; */
    display: inline-block;
    background: white;
    padding-top: 140px;
  }

  .intro .imagen {
    width: 50%;
    display: inline-block;
    height: 500px;
  }

  .intro .imagen img {
    max-width: 100%;
    max-height: 100%;
  }

  .intro .texto {
    position: relative;
    justify-content: center;
    -webkit-justify-content: center;
    width: 50%;
    text-align: left;
  }

  .intro .texto .title {
    text-align: left;
  }

  .intro .texto p {
    font-size: 18px;
    line-height: 28px;
    color: #000;
    font-weight: 300;
    padding-left: 20px;
  }

  .img-ficha {
    width: 100% !important;
    margin: 0 auto;
    margin: 60px 0;
  }

  .img-ficha img {
    width: auto;
    max-width: 100%;
    margin: 0 auto;
  }

  .back {
    position: absolute;
    left: 0;
    top: 0;
    color: #3374b0;
    font-family: 'Ubuntu Mono';
    font-weight: 600;
    padding-left: 20px;
    transform: translateX(-10px);
    font-size: 20px;
  }

  .back::before {
    width: 10px;
    height: 20px;
    content: '';
    display: inline-block;
    background: url(/static/img/next-blue.svg) center/8px no-repeat;
    position: absolute;
    left: 0;
    top: 0;
    opacity: .5;
    transform: rotate(-180deg);
  }

  .saber-mas {
    padding: 50px 0 50px 0px;
  }

  .saber-mas .title {
    color: #3374b0;
  }

  .saber-mas p {
    font-size: 24px;
    line-height: 40px;
    color: #41566d;
    text-align: center;
    display: inline-block;
    color: #41566d;
  }

  .show-more {
    border: none;
    background: none;
    outline: none;
    margin-top: 20px;
    cursor: pointer;
  }

  .title.-intro {
    margin-bottom: 20px;
  }

  [data=rojo] .title.-intro {
    color: #df1517;
  }

  [data=rojo] .title.-intro::before {
    background: #df1517;
  }

  [data=gris] .title.-intro {
    color: #41566d;
  }

  [data=gris] .title.-intro::before {
    background: #41566d;
  }

  [data=verde] .title.-intro {
    color: #51ac34;
  }

  [data=verde] .title.-intro::before {
    background: #51ac34;
  }

  [data=azul] .title.-intro {
    color: #3374b0;
  }

  [data=azul] .title.-intro::before {
    background: #3374b0;
  }

  [data=negro] .title.-intro {
    color: #1d1d1d;
  }

  [data=negro] .title.-intro::before {
    background: #1d1d1d;
  }

  .stats>div {
    width: 50%;
    text-align: left;
    flex-grow: 1;
  }

  .stats p {
    color: #41566d;
    line-height: 28px;
    font-size: 18px;
    margin-bottom: 30px;
  }

  .stats  {
    margin-bottom: 50px;
  }

  .stats>div>div {
    padding: 50px;
  }

  .stats .utilidad {
    background: rgba(51, 116, 176, 0.1);
  }

  .stats .dirigido {
    background: #f4f4f4;
  }

  .stats .title.-intro {
    width: auto;
    color: #41566d;
  }

  .stats .title.-intro::before {
    background: #41566d;
  }

  .stats .video {
    width: 100%;
    height: 300px;
    display: inline-block;
    background: red;
    position: relative;
  }

  .stats .video button {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    border: none;
    outline: none;
    z-index: 5;
    display: inline-block;
    width: 100%;
    background: rgba(0, 0, 0, 0.5) url(/static/img/video.svg) center no-repeat;
  }

  @media screen and (max-width: 800px) {
    .stats>div {
      width: 100%;
    }

    .stats>div>div {
      padding: 30px;
    }

    .intro {
      height: auto;
      padding: 140px 30px 0 30px;
    }
  }

  @media screen and (max-width: 600px) {
    .img-ficha {
      display: none;
    }

    .intro .texto {
      width: 100%;
    }

    .back {
      position: initial;
    }

    .info-producto {
      margin-top: 20px;
    }

    .intro .imagen {
      margin: 0 auto;
      height: auto;
    }

    .intro {
      padding: 100px 0 0 0px;
    }

    .stats.container {
      padding: 0;
    }

    .stats li {
      list-style: none;
    }

    .stats>div>div {
      padding: 20px;
    }

    .saber-mas p {
      font-size: 18px;
      line-height: 28px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/views/producto-ficha.vue